module.exports = __webpack_public_path__ + "img/map.484b12de.jpg";